<template>
	<div>
		
		<div class="r-title">
			<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
			<span style="z-index: 1;position: relative;">Notifications</span>
		</div>
		
		<div style="display: flex;">
			<div class="btn-normal" :class="{ 'btn-normal-active': activebtn == 1 }" @click="changebtn(1)">System</div>
			<div class="btn-normal" :class="{ 'btn-normal-active': activebtn == 2 }" @click="changebtn(2)">Notice</div>
		</div>
		<div>
			<div style="display: flex;margin-top: 1rem;flex-direction: column;margin-top: 1rem;" v-for="(item, index) in data" :key="index" :class="{'isread':item.state}">
				<div style="display: flex;align-items: center;">
					<div class="avatar"></div>
					<div style="display: flex;flex-direction: column;">
						<div style="font-size: 1rem;font-weight: bold;">SYSTEM</div>
						<div style="font-size: 0.7rem;color: #666;margin-top: 0rem;">{{item.createdAt|format}}</div>
					</div>
				</div>
				<div style="background-color: #f8f8f8;padding: 1rem;border-radius: 0.2rem;margin-top: 1rem;cursor: pointer;" @click="changeunread(item)">
					<div style="font-size: 1rem;">{{item.content}}</div>
				</div>
			</div>
				<div v-show="data.length==0&&!loading" class="nodata-box">
					<img src="../../assets/imgs/nodata.svg" class="nodata-img">
				</div>
		</div>
	</div>
</template>

<script>
	
		import axios from 'axios'
		import {baseUrl} from '../../assets/js/public.js'
		export default {
			data() {
				return {
					type:0,
					data:[],
					activebtn:1,
					loading:true
				}
			},
			components: {
			},
			methods: {
				changebtn(type){
					this.activebtn = type
					this.getdata()
				},
				getdata(){
					this.loading = true
					this.request({
						method: 'get',
						url: '/gci/notification/list?type='+this.activebtn,
					}).then(res => {
						this.data = res.data.items
						this.loading = false
					}).catch(error => {
						console.error(error.response)
					})
				},
				changeunread(item){
					if(!item.state){
						this.request({
							method: 'post',
							url: '/gci/message/'+item.id+'/edit',
							data:{state: true}
						}).then(res => {
							for (let i in this.data) {
								if(this.data[i].id == item.id){
									this.data[i].state = true
								}
							}
						}).catch(error => {
							console.error(error.response)
						})
					}
				}
			},
			mounted() {
				this.type = this.$route.query.type
				this.getdata()
			}
		}
</script>

<style lang="scss" scoped>
	.change-btn{
		display: flex;align-items: center;justify-content: center;padding: 0.5rem 1rem;border: 1px solid #eee;margin-right: 0.5rem;cursor: pointer;
		border-radius: 0.2rem;
				font-weight: bold;
	}
	.active-btn{
		background-color: #31ffda;color: #333;border: 1px solid transparent;
	}
	.r-title{
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;
		.r-title-bg{
			width: 13rem;position: absolute;left: -0.5rem;top: -2rem
		}
	}
	
	.avatar{
		background-position: center;background-repeat: no-repeat;background-size: cover;border-radius: 0.5rem;height: 3rem;min-width: 3rem;margin-right: 1rem;
		background-image: url('../../assets/imgs/user/system-avatar.svg');
	}
	.profile{
			margin-top: 1rem;
			display: -webkit-box;
			-webkit-line-clamp: 4;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			overflow: hidden;
	}
	.main-img{
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		min-width: 10rem;
		height: 10rem;
		margin-right: 1rem;border-radius: 0.2rem;
	}
	.isread{
		opacity: 0.5;
	}
</style>